<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Category</th>
              <th>Quantition</th>
              <th>Unit Cost</th>
              <th>Discount Percentage</th>
              <th>Discount Amount</th>
              <th>Approval 1 Status</th>
              <th>Approved 1 By</th>
              <th>Approved 1 Date</th>
              <th>Approval 2 Status</th>
              <th>Approved 2 By</th>
              <th>Approved 2 Date</th>
              <th>Approval 3 Status</th>
              <th>Approved 3 By</th>
              <th>Approved 3 Date</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.purchase_order_details.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(purchase_order_detail, sr) in form.purchase_order_details"
              :key="`purchase_order_detail${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.category_id"
                  :suggestions="categories"
                  placeholder="Select Category"
                ></my-select>
                <!-- :id="`purchase_order_detail${sr}`" -->
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Quantity"
                  v-model="purchase_order_detail.quantity"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Unit Cost"
                  v-model="purchase_order_detail.unit_cost"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Discount Percentage"
                  v-model="purchase_order_detail.discount_percent"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Discount Amount"
                  v-model="purchase_order_detail.discount_amount"
                />
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approval_1_status"
                  :suggestions="statuses"
                  placeholder="Select Status"
                ></my-select>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approved_1_by_id"
                  :suggestions="users"
                  placeholder="Select Approved 1 By"
                ></my-select>
              </td>
              <td>
                <my-datepicker
                  :date.sync="purchase_order_detail.approved_1_date"
                  placeholder="Enter Approved 1 Date"
                  :id="`approved_1_date${sr}`"
                ></my-datepicker>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approved_2_status"
                  :suggestions="statuses"
                  placeholder="Select Status"
                ></my-select>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approved_2_by_id"
                  :suggestions="users"
                  placeholder="Select Approved 2 By"
                ></my-select>
              </td>
              <td>
                <my-datepicker
                  :date.sync="purchase_order_detail.approved_2_date"
                  placeholder="Enter Approved 2 Date"
                  :id="`approved_2_date${sr}`"
                ></my-datepicker>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approved_3_status"
                  :suggestions="statuses"
                  placeholder="Select Status"
                ></my-select>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="purchase_order_detail.approved_3_by_id"
                  :suggestions="users"
                  placeholder="Select Approved 3 By"
                ></my-select>
              </td>
              <td>
                <my-datepicker
                  :date.sync="purchase_order_detail.approved_3_date"
                  placeholder="Enter Approved 3 Date"
                  :id="`approved_3_date${sr}`"
                ></my-datepicker>
              </td>
              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteQuotatonDetail(purchase_order_detail)"
                    v-if="!purchase_order_detail.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      delete_purchase_order_detail_data(
                        purchase_order_detail.id
                      )
                    "
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.purchase_order_details">
              <td
                colspan="16"
                align="center"
                @click="addEmptyQuotatonDetails()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "QuotationDetailFormWidget",
  props: ["form"],
  data() {
    return {
      categories: [],
      users: [],
      statuses: [
        {
          id: 1,
          name: "Pending",
        },
        {
          id: 2,
          name: "In Process",
        },
        {
          id: 3,
          name: "Completed",
        },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("quotations/masters");
      masters = masters.data;

      masters.categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          name: category.name,
        });
      });
    },
    deleteQuotatonDetail(speed) {
      this.form.purchase_order_details =
        this.form.purchase_order_details.filter((ar) => ar != speed);
    },
    addEmptyQuotatonDetails() {
      this.form.purchase_order_details.push({
        company_id: this.company.id,
        category_id: "",
        quantity: "",
        unit_cost: "",
        discount_percent: "",
        discount_amount: "",
        approved_1_status: "",
        approved_1_by_id: "",
        approved_1_date: "",
        approved_2_status: "",
        approved_2_by_id: "",
        approved_2_date: "",
        approved_3_status: "",
        approved_3_by_id: "",
        approved_3_date: "",
      });
    },
    async delete_purchase_order_detail_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=purchase_order_details`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
